// Collection of dialogs are shown when you land on a page with a ?modalSlug query param

import * as React from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '#app/components/ui/dialog.tsx'
import { PopupModals, type PopupModalType } from '#app/services/ui/modals-constants.ts'
import { Button } from './ui/button'

//
function ExpiredForConcurrentConnections() {
	const [openDialog, setOpenDialog] = React.useState(true)
	const navigate = useNavigate()

	return (
		<Dialog open={openDialog} onOpenChange={setOpenDialog}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Sesión expirada</DialogTitle>
				</DialogHeader>
				<div className="flex flex-col gap-4 py-6">
					<p className="text-sm">
						Tu sesión ha expirado porque has superado el número máximo de conexiones permitidas. Chequea que solo tú
						tengas acceso a tu cuenta.
					</p>
					<small className="text-neutral-500">
						Si tienes dudas, puedes iniciar una nueva sesión(esto cerrara el resto de sesiones abiertas) y cambiar tu
						contraseña.
					</small>
				</div>
				<DialogFooter>
					<Button variant="outline" asChild onClick={() => setOpenDialog(false)}>
						{/* TODO: added ? to the end to remove current search params */}
						<Link to="/login?" prefetch="viewport" replace>
							Iniciar sesión de nuevo
						</Link>
					</Button>
						<Button
							variant="outline"
							onClick={() => {
								void navigate('/', { replace: true }) // to remove the search params
								setOpenDialog(false)
							}}
						>
						Salir
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}

const rendered = {
	value: false,
}

export function ModalsOnQueryParams() {
	const [show, setShow] = React.useState<PopupModalType>()
	const [searchParams] = useSearchParams()

	React.useEffect(() => {
		let modalSlug = searchParams.get('modalSlug')
		if (modalSlug && !rendered.value) {
			setShow(modalSlug as PopupModalType)
			rendered.value = true
		}
	}, [searchParams])

	switch (show) {
		case PopupModals.sessionExpiredForConcurrentConnections:
			return <ExpiredForConcurrentConnections />
		default:
			return null
	}
}
